import { Switches } from '@occc-app/design-system';

import { LimitFormContent } from '../limit-form-content';
import { LimitFormContentLayout } from '../limit-form-content-layout';
import { LimitComponentProps } from '../../types';

export const PerMemberActivationLimit = ({ open }: LimitComponentProps) => (
  <LimitFormContentLayout
    title='Per Member Activation Limit'
    description='Limits activation based on the number of times the offer has generated an activation for a single membership'
    action={<Switches name='activation.membership.isEnabled' data={{}} />}
    open={open}
  >
    <LimitFormContent name='activation.membership' />
  </LimitFormContentLayout>
);
